import { Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { PositionSettingsInterface } from '@shared/components/trading/widgets/positions-widget/core/interfaces/position-settings.interface'
import { PositionsComponent } from '@shared/components/trading/positions/positions.component'

@Component({
	selector: 'app-positions-widget',
	templateUrl: './positions-widget.component.html',
	styleUrl: './positions-widget.component.scss',
	imports: [PositionsComponent],
})
export class PositionsWidgetComponent {
	public widget: InputSignal<WidgetInterface<PositionSettingsInterface> | null> =
		input<WidgetInterface<PositionSettingsInterface> | null>(null)
}
